import { all, call, fork, put, takeEvery } from 'redux-saga/effects';

// actions
import { doneIndicator, error } from '../../actions/standardActions';
import { push } from 'react-router-redux';

// api
import repAPI from '../../sources/api/repAPI';
import tokenAPI from '../../sources/api/tokenAPI';

// constants
import { CURRENT_REP_CREATE } from '../../constants/currentRepTypes';
import { TOKEN_CREATE } from '../../constants/tokenTypes';

// lib
import handleServerValidation from '../../lib/handleServerValidation';
import httpSaga from '../../lib/httpSaga';

function isRepValid(errors) {
  return (
    !Object
      .keys(errors)
      .some((el) => ['name', 'company', 'specialty', 'products', 'phoneNumber'].includes(el))
  );
}

function isUserValid(errors) {
  return (
    !Object
      .keys(errors)
      .some((el) => ['user.email', 'user.password'].includes(el))
  );
}

export function* currentRepCreate(action) {
  if (action['@@redux-saga/SAGA_ACTION']) return;

  const { currentStep, ...params } = action.payload;
  const phoneNumber                = params.phoneNumber;

  if (phoneNumber) {
    params.phoneNumber = `+1${phoneNumber.replace(/\D+/g, '')}`;
  }

  try {
    yield *httpSaga(CURRENT_REP_CREATE, call(repAPI.create, params));
    yield *httpSaga(TOKEN_CREATE, call(tokenAPI.create, params.email, params.password));

    yield put(push('/reps/new/3'));
  } catch (e) {
    let errors = handleServerValidation('rep', e.response.body.details, { nestedPath: true });

    if (currentStep === 1 && isUserValid(errors)) {
      yield put(push('/reps/new/2'));

      errors = {};
    } else if (currentStep === 2 && isRepValid(errors)) {
      yield put(push('/reps/new/1'));

      errors = {};
    }

    yield put(error(CURRENT_REP_CREATE, errors));
  } finally {
    yield put(doneIndicator(CURRENT_REP_CREATE));
  }
}

export function* watchCurrentRepCreate() {
  yield takeEvery(CURRENT_REP_CREATE, currentRepCreate);
}

export default function* root() {
  yield all([
    fork(watchCurrentRepCreate)
  ]);
}



// WEBPACK FOOTER //
// ./app/sagas/rep/currentRepCreate.js